<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="TIPO DE AUSENTIMOS" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                @action="masterAction"
                @params="paramsTable"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Tipo de Ausentismo')">
                <a-input
                  v-decorator="['abs_type_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Medida')">
                <a-input
                  v-decorator="['abs_type_measure', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
            <g-lookup endpoint="coc"
                        :label="$t('Concepto:')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_coc', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      ref="concepto"
            >
            </g-lookup>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    data () {
      return {
        fileNameExcel: 'tipo_ausentismo',
        paramsT: {},
        endpointExcel: 'absen_type_/downloadExcel',
        pageTitle: 'Tipo de ausentismos',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'absen_type',
          tableSetup: {
            tableConfig: {
              rowKey: 'abs_type'
            },
            columns: [
              {title: '#', dataIndex: 'abs_type', sorter: true},
              {title: 'Tipo de Ausentismo', dataIndex: 'abs_type_name', sorter: true},
              {title: 'Medida', dataIndex: 'abs_type_measure', sorter: true},
              {title: 'Concepto', dataIndex: 'concepto', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by'},
              {title: 'Creado', dataIndex: 'created_on'},
              {title: 'Modificado por', dataIndex: 'modified_by'},
              {title: 'Modificado', dataIndex: 'modified_on'}
            ]
          },
          modalFieldsSetup: [
            {name: 'abs_type_measure'},
            {name: 'abs_type_name'},
            {name: 'id_coc'}
          ]
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterEdit':
            if (!this.$isEmpty(action.record.id_coc)) {
              this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
            }
            break
        }
      },
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/AbsenType.vue